import {createRoot} from 'react-dom/client'
// Axios
import {Chart, registerables} from 'chart.js'
import {QueryClient, QueryClientProvider} from 'react-query'
import {ReactQueryDevtools} from 'react-query/devtools'
// Apps
import {MetronicI18nProvider} from './_metronic/i18n/Metronici18n'
import './_metronic/assets/fonticon/fonticon.css'
import './_metronic/assets/keenicons/duotone/style.css'
import './_metronic/assets/keenicons/outline/style.css'
import './_metronic/assets/keenicons/solid/style.css'
/**
 * TIP: Replace this style import with rtl styles to enable rtl mode
 *
 * import './_metronic/assets/css/style.rtl.css'
 **/
import './_metronic/assets/sass/style.scss'
import './_metronic/assets/sass/plugins.scss'
import './_metronic/assets/sass/style.react.scss'
import {AppRoutes} from './app/routing/AppRoutes'
import {AuthProvider} from './app/modules/auth'
import {NotificationProvider} from "./app/context/NotificationContext";
import {DeleteModalProvider} from "./app/context/DeleteModalContext";
import {StepProvider} from "./app/context/StepContext";
import {Provider} from "react-redux";
import store from "./app/store";

Chart.register(...registerables)
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    }
  }
})
const container = document.getElementById('root')
if (container) {
  createRoot(container).render(
      <QueryClientProvider client={queryClient}>
        <MetronicI18nProvider>
          <NotificationProvider>
            <AuthProvider>
              <DeleteModalProvider>
                <StepProvider>
                  <Provider store={store}>
                    <AppRoutes/>
                  </Provider>
                </StepProvider>
              </DeleteModalProvider>
            </AuthProvider>
          </NotificationProvider>
        </MetronicI18nProvider>
        <ReactQueryDevtools initialIsOpen={false}/>
      </QueryClientProvider>
  )
}
